import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { GridRow } from '@mui/x-data-grid';
import ONBOARDING_TOOLTIP_CLASS_NAME from '../../theme/constants/tooltip';

const DataGridRowWithTooltip = ({
  disabledRowTooltip,
  isRowSelectable,
  row,
  tooltipClassName,
  ...props
}) => {
  const isDisabled = isRowSelectable && !isRowSelectable({ row });
  const tooltipTitle = disabledRowTooltip(row);

  if (!isDisabled || !tooltipTitle) {
    return <GridRow row={row} {...props} />;
  }

  return (
    <Tooltip
      title={tooltipTitle}
      placement="bottom-start"
      classes={{ tooltip: tooltipClassName }}
    >
      <GridRow row={row} {...props} />
    </Tooltip>
  );
};

export default DataGridRowWithTooltip;

DataGridRowWithTooltip.propTypes = {
  disabledRowTooltip: PropTypes.func,
  isRowSelectable: PropTypes.func,
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  tooltipClassName: PropTypes.string,
};

DataGridRowWithTooltip.defaultProps = {
  tooltipClassName: ONBOARDING_TOOLTIP_CLASS_NAME,
  disabledRowTooltip: () => '',
  isRowSelectable: null,
};
